import clsx from 'clsx';
import IconSvg, { Icons } from 'src/assets/icons/IconSvg';

interface Props {
  children?: React.ReactNode;
  className?: string;
  variant?: 'dark' | 'transparent';
  size?: 'xs' | 'sm' | 'md';
  disabled?: boolean;
  onClick?: () => void;
  icon?: Icons;
  iconPosition?: 'left' | 'right';
  onlyIcon?: boolean;
}

const IconButton = ({
  children,
  className,
  variant = 'dark',
  size = 'md',
  disabled,
  onClick,
  icon,
  iconPosition = 'left',
  onlyIcon = false,
}: Props) => {
  const getButtonColor = () => {
    switch (variant) {
      case 'dark':
        return 'bg-grayscale-600 text-brand-magnolia hover:bg-grayscale-500';
      case 'transparent':
        return 'bg-transparent text-grayscale-200 border border-transparent hover:border-grayscale-500';
      default:
        return 'bg-brand-magnolia text-brand-black hover:bg-grayscale-400';
    }
  };

  const getButtonSize = () => {
    switch (size) {
      case 'xs':
        return 'px-4 text-sm h-[34px]';
      case 'sm':
        return 'px-4 py-2.5 text-lg';
      case 'md':
        return 'px-4 py-3 text-lg';
      default:
        return 'px-4 py-2 text-lg h-12';
    }
  };

  const buttonClasses = clsx(
    'font-semibold rounded-lg flex-shrink-0 flex items-center gap-2 justify-center',
    getButtonColor(),
    getButtonSize(),
    className,
    onlyIcon && size !== 'md' ? '!p-2.5' : '!p-3',
  );

  return (
    <button className={buttonClasses} disabled={disabled} onClick={onClick}>
      {icon && iconPosition === 'left' && <IconSvg icon={icon} />}

      {children}

      {icon && iconPosition === 'right' && <IconSvg icon={icon} />}
    </button>
  );
};

export default IconButton;
